import { ContentImageProps } from 'components/molecules/ContentImage/ContentImage';
import { TrackingDescriptionIDType } from 'defs/tracking';
import {
	initialState,
	RootStateType,
	TrackingDescriptionInternalType,
	TrackingDescriptionStateType,
	TrackingDescriptionType,
} from './trackingDescription';

export const getState = (state: RootStateType): TrackingDescriptionStateType =>
	state.trackingDescription || initialState;

export const getIsLoaded = (state: RootStateType): boolean => getState(state).loaded;

export const getIsGuideOpen = (state: RootStateType, guideId: TrackingDescriptionIDType): boolean => {
	return Boolean(getState(state)[guideId]);
};

export const getDescriptionForGuide = (
	state: RootStateType,
	guideId: TrackingDescriptionIDType
): TrackingDescriptionType | undefined => {
	const internalState = getState(state);

	if (!Array.isArray(internalState.descriptions)) {
		return;
	}

	const description = internalState.descriptions.find((desc: TrackingDescriptionInternalType) => {
		return desc.type === guideId;
	});

	if (!description) {
		return;
	}

	const contentImages = description.images.map(
		(wrapper, index): ContentImageProps => {
			const { image, link, showIcon = false } = wrapper;

			return {
				image: image as any,
				lightbox: {
					image: {
						srcset: image.lightboxSrcset,
						fallback: image.lightboxSrcset ? image.lightboxSrcset.fallback : undefined,
					} as any,
				},
				slide: [index + 1, description.images.length],
				caption: {
					title: image.title,
					text: image.text,
					links: link
						? [
								{
									externalHref: link.href,
									openInNewWindow: link.openInNewWindow,
									title: link.title,
									icon: showIcon ? 'cart' : null,
								},
						  ]
						: [],
				} as any,
			};
		}
	);

	return {
		type: description.type,
		headLine: description.headLine,
		images: contentImages,
	};
};
